fx.service( class GoogleService extends fx.Service
{
    constructor(model)
    {
        super();

        this.model = model.creationModel;

        this.data = this.model.google;

        this._init();

		this._client;
		this._accessToken = null;
		this._loadedPhotosAtOnce = [];

		this._NUM_ELEMENTS = fx.browser.isMobile ? 25 : 50;
    }

	/*
	*
    *  // ------------- EXTRACTOR -------------- //
    *
    */

	get processing()
	{
		return this._googleExtractor && this._googleExtractor.processing;
	}

	get total()
	{
		return this._googleExtractor ? this._googleExtractor.total : 0;
	}

	get position()
	{
		return this._googleExtractor ? this._googleExtractor.position : 0;
	}

	_init()
	{
		if (!this._googleExtractor)
		{
			this._googleExtractor = new shared.extractors.GoogleExtractor({data : this.model});
			this.on("photo-extracted", this._onGooglePhotoExtracted, this._googleExtractor);
		}
	}

    _onGooglePhotoExtracted(e)
	{
		// send pictures to MediaUpoloader so they can be stored on server
		 fx.service("MediasUploader").upload(e.detail);
	}

    upload(selectedPhotos)
    {
		this._googleExtractor.process(selectedPhotos);
    }

	/*addRawPhotos(datas)
	{
		let photos = [];
		for(let i = 0; i < datas.mediaItems.length; i++)
			photos.push(this._convertPhoto(datas.mediaItems[i]));

		this.upload(photos);
	}*/

    /*
	*
    *  // ------------- GOOGLE SDK -------------- //
    *
    * Some browsers (mobile and desktop) block popups unless they are initiated by a user click.
    * So this._GoogleAuth.signIn() function must be called only in response to the user's click
    *
    */
   
	initSDK()
	{
		this._initGoogleSDK();
	}

    getPhotos(album)
    {
		if (album.id === 0)
			this._getMainAlbumPhotos(album)
		else
			this._getPhotos(album)
    }

	// ----------------- GET GOOGLE SKD  ------------------- //

	_initGoogleSDK()
	{
		if (this._client==undefined) {
			this.xhr = $.getScript('https://accounts.google.com/gsi/client', () => {
				this.xhr = null;
				this._initTokenClient();
			});
		}
		else
		{
			this._initTokenClient();
		}
	}

	// ------------------ AUTHENTICATION  -------------------- //

	// STEP 1 => initialize client

	_initTokenClient()
	{
		if (this.data.length)
			this.data.removeAll();

		// Pre-login configuration step. Keep users sessions informations in this._client .
		// !!! requestAccessToken() function must be called in order to log-in and generate user token.
		this._client = google.accounts.oauth2.initTokenClient({
			// deprecated ? apiKey: 'h7l3IggA9h4rYkCFaFCjKWL7',
			client_id: '312072992255-qurkfdksm30hueojvl0j9m38bcm1dsmk.apps.googleusercontent.com',
			scope: 'https://www.googleapis.com/auth/photoslibrary.readonly https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
			callback: this._loginCallback.bind(this),
		  });
	}

	// STEP 2 => Log-in user when clicking on google connexion button

	login()
    {
		if(this._client)
			this._client.requestAccessToken();	// log-in and ask this._client to generate token in _loginCallback
    }

	// STEP 3 => callback called in case of sucessful / failed connexion

	_loginCallback(tokenResponse)
	{
		if(tokenResponse.error)
		{
			fx.log.error(error);
			this.data.event("google-photos-error");
		}
		else
		{
			if (tokenResponse && tokenResponse.access_token) {
				if (google.accounts.oauth2.hasGrantedAllScopes(tokenResponse,
					'https://www.googleapis.com/auth/photoslibrary.readonly', 
					'https://www.googleapis.com/auth/userinfo.profile',
					'https://www.googleapis.com/auth/userinfo.email')) {
						this._accessToken = tokenResponse.access_token;

						this._getUserInfos();
						this._getAlbums(null);
						
						if(window.fx.browser.isMobile || window.fx.browser.isTablet)
							this.data.event("show-google-albums");
						else
							this.data.event("show-google-photos");
				}
			}
		}
	}

	disconnect(){
		if (this._accessToken != null) {
            google.accounts.oauth2.revoke(this._accessToken);
			this._accessToken = null;
		}
	}

	// ---------------------- GET ALBUMS  ---------------------- //

	_getUserInfos(){
		let url = `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${this._accessToken}`;
		fetch(url)
			.then(response => response.json())
			.then(data => this.data.event("google-photos-userinfos", data))
			.catch(error => fx.log.error(error));
	}

	_getAlbums(nextPhotos)
	{
		let url = `https://photoslibrary.googleapis.com/v1/albums/?access_token=${this._accessToken}&pageSize=${this._NUM_ELEMENTS}`;

		if (nextPhotos) url += `&pageToken=${nextPhotos}`;

		fetch(url)
			.then(response => response.json())
			.then(data => {
				if (data.albums && data.albums.length > 0) 
					this._addAlbums(data);
				else
					this._getMainAlbumPhotos();
			})
			.catch(error => {
				fx.log.error(error);
				this.data.event("google-photos-error");
			});
	}

	_addAlbums(albumsData)
	{
		if (!this.data.length) {
			this.data.addAlbum(this._createMainAlbum());
		} 

		for (let i = 0; i < albumsData.albums.length; i++)
		{
			if (albumsData.albums[i].mediaItemsCount > 0)
				this.data.addAlbum(this._convertAlbum(albumsData.albums[i]));
		}

		if (albumsData.nextPageToken)
			this._getAlbums(albumsData.nextPageToken);
		else
			this._getMainAlbumPhotos();
	}

	_createMainAlbum()
	{
		let mainalbum = {};
		mainalbum.id = 0;
		mainalbum.name = 'Photos';
		mainalbum.count = 0;
		mainalbum.cover_url = null;
		mainalbum.photos = new fx.ModelArray([]);
		mainalbum.nextPhotos = null;
		mainalbum.isLoaded = false;
		mainalbum.isActive = true;
		mainalbum.isMain = true;
		mainalbum._m = "GoogleAlbumModel";
		return mainalbum;
	}

	_convertAlbum(googleAlbum)
	{
		let album = {};
		let thumbnail = `${googleAlbum.coverPhotoBaseUrl}=w256-h256-c`;

		album.id = googleAlbum.id;
		album.name = googleAlbum.title;
		album.count = googleAlbum.mediaItemsCount;
		album.cover_url = googleAlbum.coverPhotoBaseUrl;
		album.thumbnail = thumbnail;
		album.photos = new fx.ModelArray([]);
		album.nextPhotos = null;
		album.isLoaded = false;
		album.isActive = false;
		album._m = "GoogleAlbumModel";
		return album;
	}

	// ---------------------- GET PHOTOS  ----------------------- //

	_getMainAlbumPhotos(album)
	{
		let url = `https://photoslibrary.googleapis.com/v1/mediaItems?access_token=${this._accessToken}&pageSize=${this._NUM_ELEMENTS}`;

		if (album)
		{
			if (album.nextPhotos || album.nextPageToken)
				url += `&pageToken=${album.nextPhotos || album.nextPageToken}`;
		}

		fetch(url)
			.then(response => response.json())
			.then(data => {
				if (data.mediaItems && data.mediaItems.length > 0) this._addPhotos(data);

				if (!data.mediaItems && data.nextPageToken) this._getMainAlbumPhotos(data);
			})
			.catch(error => {
				fx.log.error(error);
				this.data.event("google-photos-error");
			});
	}

	_addPhotos(photosData, album)
	{
		if (!photosData || !photosData.mediaItems || photosData.mediaItems.length == 0)
			return;

		this.data.lazyLoadingActive = 0;

		album = album || this.data.find({id : 0});

		if (!album)
		{
			album = this._createMainAlbum();
		}

		let albumPhotos = photosData.mediaItems.filter(
			item => item.mimeType === 'image/jpeg' 
				 || item.mimeType === 'image/png'
				 || item.mimeType === 'image/heif'
		);

		
		if (!albumPhotos.length) {
			album.isLoaded = true;
			album.count = 0;
			return;
		}

		albumPhotos = albumPhotos.map(photo => this._convertPhoto(photo));

		if (album.id === 0) {
			if (!album.thumbnail) 
				album.cover_url = album.thumbnail = albumPhotos[0].thumb;

			album.count = album.photos.length;
		}

		this.data.addItem(album);

		for (let i = 0; i < albumPhotos.length; i++)
		{
			this.data.addPhoto(album, albumPhotos[i]);
		}

		if (photosData.nextPageToken)
			album.nextPhotos = photosData.nextPageToken;
		else {
			album.isLoaded = true;
			album.nextPhotos = null;
		}

		// trick because google doesn't send back exact number of picture required by pageSize
		this._loadedPhotosAtOnce = this._loadedPhotosAtOnce.concat(albumPhotos);

		if (photosData.nextPageToken && this._loadedPhotosAtOnce.length < this._NUM_ELEMENTS) {

			if (album.id === 0)
				this._getMainAlbumPhotos(album);
			else
				this._getPhotos(album);
			
		} 
		else
		{
			this._loadedPhotosAtOnce = [];
			this.trigger("photos-loaded");
		}
	}

	_convertPhoto(googlePhoto)
	{
		let { baseUrl, id, mediaMetadata, productUrl } = googlePhoto;

		let photo = { baseUrl, id, mediaMetadata, productUrl };

		photo.thumb = `${baseUrl}=w256-h256-c`;

		photo.fullSize_url = `${baseUrl}=w${mediaMetadata.width}-h${mediaMetadata.height}`;
		photo._m = "GooglePhotoModel";

		return photo;
	}

	_getPhotos(album)
	{
		let url = `https://photoslibrary.googleapis.com/v1/mediaItems:search?access_token=${this._accessToken}&albumId=${album.id}&pageSize=${this._NUM_ELEMENTS}`;

		if (album.nextPhotos)
			url += `&pageToken=${album.nextPhotos}`;

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
			},
		})
			.then(response => response.json())
			.then(data => {
				if (data.mediaItems && data.mediaItems.length > 0) 
					this._addPhotos(data, album);
				else
					this._addPhotos({mediaItems:[]}, album);
			})
			.catch(error => { this._addPhotos({mediaItems:[]}, album); } );
	}

});